import { render } from "./WhyMe.vue?vue&type=template&id=3476cfd7"
import script from "./WhyMe.vue?vue&type=script&lang=js"
export * from "./WhyMe.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__